import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { concatAndDeDuplicateObjects } from '@/lib/utils';

interface MaterialItem {
  id: string;
  [key: string]: any;
}

interface MaterialsState {
  items: MaterialItem[];
  loading: boolean;
  error: string | null;
}

const initialState: MaterialsState = {
  items: [],
  loading: false,
  error: null,
};

const materialsSlice = createSlice({
  name: 'materials',
  initialState,
  reducers: {
    // Local action for adding material numbers
    addMaterialNumber: (state, action: PayloadAction<MaterialItem>) => {
      state.items = [action.payload, ...state.items];
    },
    // Refresh materials actions
    refreshMaterialsStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    refreshMaterialsCommit: (state, action: PayloadAction<{ materials: MaterialItem[] }>) => {
      state.loading = false;
      state.items = action.payload.materials || [];
      state.error = null;
    },
    refreshMaterialsFailed: (state, action: PayloadAction<{ error: string }>) => {
      state.loading = false;
      state.error = action.payload.error;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase('GET_BOOKINGS_COMMIT', (state, action: PayloadAction<{
        materials?: MaterialItem[];
        page?: number;
      }>) => {
        if (action.payload.page) {
          if (action.payload.materials && action.payload.materials.length > 0) {
            state.items = concatAndDeDuplicateObjects('id', state.items, action.payload.materials);
          }
        } else {
          state.items = action.payload.materials || [];
        }
      })
      .addCase('materials/refreshMaterials', (state) => {
        state.loading = true;
        state.error = null;
      });
  },
});

export const {
  addMaterialNumber,
  refreshMaterialsStart,
  refreshMaterialsCommit,
  refreshMaterialsFailed,
} = materialsSlice.actions;

export default materialsSlice.reducer;

